import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  @Input() exclude: string = '';
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: any) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    const clickedExcluded = this.exclude ? 
      document.querySelector(this.exclude)?.contains(target) : 
      false;

    if (!clickedInside && !clickedExcluded) {
      this.clickOutside.emit();
    }
  }
} 